import { Button } from 'ccs-ui-components';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { SidebarDataLoadingState } from '../../../modules/journey-canvas/utility/TypeDefs';
import { JourneyComments } from '../../../store/_api/TypeDefs';
import classes from './CommentHistoryModal.module.scss';

interface IListOfCommentsProp {
  listOfComments: JourneyComments[] | undefined,
  hideSidebar: () => void,
  sidebarDataLoadingState: SidebarDataLoadingState
}

const CommentHistoryModal: React.FC<IListOfCommentsProp> = ({ listOfComments = [], hideSidebar, sidebarDataLoadingState }: IListOfCommentsProp) => {
  const [showLastComment, setShowLastComment] = useState<boolean>(true);
  const [noOfPastComments, setNoOfPastComments] = useState<number>();
  const [lastComment, setLastComment] = useState<JourneyComments>();
  const [previousComments, setPreviousComments] = useState<JourneyComments[]>([]);

  const { t: translate } = useTranslation();

  useEffect(() => {
    setNoOfPastComments(listOfComments.length - 1);
    setLastComment(listOfComments[0]);
    if (listOfComments.length > 1) {
      setPreviousComments(listOfComments.slice(1));
    }
  }, [listOfComments]);

  const generateInitials = (name: string | undefined) => {
    if (name) {
      const initials = name.replace(/[^a-zA-Z]/g, '');
      if (initials.length > 0) {
        return initials.slice(0, 2).toUpperCase();
      }

      return 'AB';
    }
    return 'AB';
  };

  function getConstructedDate(dateObj: string | undefined) {
    if (dateObj) {
      const currentDate = moment(dateObj).format('MM/DD/YYYY');
      return currentDate;
    }
    return '-';
  }

  function getDateInTime(dateObj: string | undefined) {
    if (dateObj) {
      const currentDate = moment(dateObj).fromNow();
      return currentDate;
    }
    return '-';
  }

  const accordianHandler = () => {
    setShowLastComment(!showLastComment);
  };

  return (
    <div className={classes['sidebar-heading']} data-testid="associatedSideBarHeader">
      <div className={classes['close-sidebar']}>
        <p className={classes['sidebar-title']} data-testid="sidebarTitle">{translate('comment_history.txt_reason_for_return')}</p>
        <Button variant="tertiary" data-testid="sidebarCloseBtn" onClick={hideSidebar}>
          <i className="fa-solid fa-xmark" />
        </Button>
      </div>
      {sidebarDataLoadingState === SidebarDataLoadingState.NONE && (
        <div className={classes['return-dialog']}>
          {showLastComment ? (
            <div>
              <div className={classes['user-details']}>
                <div className={classes['user-avatar']}>
                  {generateInitials(lastComment?.createdBy)}
                </div>
                <div className={classes['user-bio']}>
                  <div className={classes['user-name']} title={lastComment?.createdBy}>
                    {lastComment?.createdBy}
                  </div>
                  <div className={classes['user-designation']}>
                    {translate('comment_history.txt_approver')}
                  </div>
                </div>
                <div className={classes['user-duration']}>
                  {getDateInTime(lastComment?.createdTimestamp)}
                </div>
              </div>
              <div className={classes['user-content']}>
                {lastComment?.comments}
              </div>
              <div className={classes['user-status']}>
                <i className={`${classes['clock-pending']} bi bi-clock`} />
                {' '}
                {translate('comment_history.txt_pending')}
              </div>
            </div>) : ''}
          {noOfPastComments ? (
            <Accordion className={classes['user-history']} flush>
              <Accordion.Item className={`${!showLastComment ? classes['background-accordian-item'] : ''}`} eventKey="0">
                <Accordion.Header onClick={accordianHandler}>
                  {showLastComment ? (
                    <div className={classes['past-comments-div']}>
                      <span className={classes['past-comment-link']}>{translate('comment_history.txt_show_comments')} ({noOfPastComments})</span>
                      <i className={`${classes['past-comment-header-chevron']} bi bi-chevron-down`} />
                    </div>
                  ) : (
                    <div className={classes['past-comments-div']}>
                      <span className={classes['past-comment-link']}>{translate('comment_history.txt_hide_comments')} ({noOfPastComments})</span>
                      <i className={`${classes['past-comment-header-chevron']} bi bi-chevron-up`} />
                    </div>
                  )}
                </Accordion.Header>
                <Accordion.Body className={classes['past-comments-wrapper']}>
                  {previousComments?.map((comment) => (
                    <div className={classes['past-comment-item']} key={comment.createdTimestamp.toString()}>
                      <div className={classes['user-details-for-past']}>
                        <div className={classes['user-avatar']}>
                          {generateInitials(comment.createdBy)}
                        </div>
                        <div className={classes['user-bio']}>
                          <div className={classes['user-name']} title={comment.createdBy}>
                            {comment.createdBy}
                          </div>
                          <div className={classes['user-designation']}>
                            {translate('comment_history.txt_approver')}
                          </div>
                        </div>
                        <div className={classes['user-duration']}>
                          {getConstructedDate(comment.createdTimestamp)}
                        </div>
                      </div>
                      <div className={classes['user-content']}>
                        {comment.comments}
                      </div>
                    </div>))}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ) : ''}
        </div>)}
    </div>
  );
};

export default CommentHistoryModal;
